import { useLocation } from 'react-router-dom'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useAssetLibraries from '@hooks/useAssetLibraries'

import AssetLibraryListItem from '../AssetLibraryListItem'

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const BrandAssetLibraries = (props: PageContentProps) => {
  const { pageFilters } = props

  useLocation()

  const { selectedAgency } = useAgencySelector()

  const assetLibrariesPayload = useAssetLibraries({
    filters: {
      owner_id: selectedAgency?.brand_id,
      owner_type: 'Brand',
      ...pageFilters,
    },
    performHttpRequests: true,
    requestOptions: {
      include_asset_library_attachments_count: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredAssetLibraries,
    filteredAssetLibrariesCount,
    hasFilteredAssetLibraries,
    loaded,
    loading,
  } = assetLibrariesPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
      loading={loading && !loaded}
      title="Brand Document Libraries"
    >
      {!loading && !hasFilteredAssetLibraries && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Brand Document Libraries Present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {loaded && hasFilteredAssetLibraries && (
        <Box flexDirection="column">
          <DashboardModule.ScrollableSection>
            {filteredAssetLibraries.map(assetLibrary => (
              <AssetLibraryListItem
                assetLibrary={assetLibrary}
                key={assetLibrary.id}
              />
            ))}
          </DashboardModule.ScrollableSection>

          <DashboardModule.LoadMoreFooter
            callbacks={{ loadMore }}
            canLoadMore={canLoadMore}
            entityCount={filteredAssetLibrariesCount}
            loading={loading}
          />
        </Box>
      )}
    </DashboardModule>
  )
}

export default BrandAssetLibraries
